import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapTopHeader = React.lazy(function () {
    return import('../../bootstrap-components/components/BTTopHeader');
});
var bootStrapTopHeader = function (props) {
    return React.createElement(BootStrapTopHeader, __assign({}, props), props.children);
};
var TopHeader = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapTopHeader(props);
            break;
        default:
            componentToDisplay = bootStrapTopHeader(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
TopHeader.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(TopHeader);
//# sourceMappingURL=TopHeader.js.map